var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCompetitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.143555,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10481_23906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 16H11V13H9V16H6V18H9V21H11V18H14V16ZM24 17C25.66 17 26.99 15.66 26.99 14C26.99 12.34 25.66 11 24 11C23.68 11 23.37 11.05 23.09 11.14C23.66 11.95 23.99 12.93 23.99 14C23.99 15.07 23.65 16.04 23.09 16.86C23.37 16.95 23.68 17 24 17ZM19 17C20.66 17 21.99 15.66 21.99 14C21.99 12.34 20.66 11 19 11C17.34 11 16 12.34 16 14C16 15.66 17.34 17 19 17ZM25.62 19.16C26.45 19.89 27 20.82 27 22V24H30V22C30 20.46 27.63 19.51 25.62 19.16ZM19 19C17 19 13 20 13 22V24H25V22C25 20 21 19 19 19Z",
    fill: "#787878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10481_23906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCompetitor);
export default __webpack_public_path__ + "static/media/addCompetitor.8390b3ae7c62e1dd5d4ae3f4e427b331.svg";
export { ForwardRef as ReactComponent };